import { useState } from 'react'
import { Lock, X } from 'lucide-react'

interface AdminCodeVerificationProps {
  onSuccess: () => void
  onCancel: () => void
  action: string
}

export default function AdminCodeVerification({ onSuccess, onCancel, action }: AdminCodeVerificationProps) {
  const [code, setCode] = useState('')
  const [error, setError] = useState('')
  const [isVerifying, setIsVerifying] = useState(false)

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    setIsVerifying(true)
    setError('')

    // Simulate verification delay
    setTimeout(() => {
      if (code === '5070') {
        onSuccess()
      } else {
        setError('Ungültiger Admin-Code')
      }
      setIsVerifying(false)
    }, 500)
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-yellow-100 rounded-lg">
              <Lock className="w-5 h-5 text-yellow-600" />
            </div>
            <h3 className="text-lg font-semibold">Admin-Berechtigung erforderlich</h3>
          </div>
          <button onClick={onCancel} className="text-gray-500 hover:text-gray-700">
            <X className="w-5 h-5" />
          </button>
        </div>

        <p className="text-gray-600 mb-4">
          Für <strong>{action}</strong> ist ein Admin-Code erforderlich.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="form-label">Admin-Code</label>
            <input
              type="password"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              className={`form-input ${error ? 'border-red-500' : ''}`}
              placeholder="4-stelliger Code eingeben"
              maxLength={4}
              autoFocus
            />
            {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
          </div>

          <div className="flex gap-3">
            <button
              type="submit"
              disabled={isVerifying || code.length !== 4}
              className="btn btn-primary flex-1"
            >
              {isVerifying ? 'Verifiziere...' : 'Bestätigen'}
            </button>
            <button
              type="button"
              onClick={onCancel}
              className="btn btn-secondary"
            >
              Abbrechen
            </button>
          </div>
        </form>

        <div className="mt-4 p-3 bg-gray-50 rounded">
          <p className="text-xs text-gray-600">
            <strong>Hinweis:</strong> Der Admin-Code ist nur berechtigten Personen bekannt und wird für alle kritischen Verwaltungsaktionen benötigt.
          </p>
        </div>
      </div>
    </div>
  )
}
